import axios from 'axios';

axios.defaults.baseURL = 'https://sbc-backend.goit.global';

// send email for reset password
export const sendEmailApi = body => {
  return axios.post('/auth/password/requestReset', body);
};

export const setNewPasswordApi = ({ token, newPassword }) => {
  return axios.post('/auth/password/reset', { token, newPassword });
};

export const changeTaskIsDoneApi = taskId => {
  return axios
    .patch('/task/changeStatus/' + taskId)
    .then(({ data }) => data)
    .catch(err => {
      throw err;
    });
};
